import React, { useEffect, useState } from "react";
import { ReactComponent as ArrowBackIcon } from "assets/images/common/svgs/arrow_back.svg";
import editProfilePicUser from "assets/images/common/others/editProfileUSer.png";
import { useNavigate } from "react-router-dom";
import useUtils from "hooks/useUtils";
import { useSelector } from "react-redux";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import useBusinessManagement from "../useHooks";
import { siteRoutes } from "utils/helpers/enums/routes.enum";

interface Tab {
  name: string;
  Component: JSX.Element;
}

const ViewBusinessDetail = () => {
  const navigate = useNavigate();
  const [businessDetail, setBusinessDetail] = useState<any>({});
  const { getBusinessDetailById } = useBusinessManagement();
  const { getQueryParams } = useUtils();
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const params = getQueryParams();
  const goToBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    getBusinessDetailById(params?.id, setBusinessDetail);
  }, []);

  console.log(businessDetail);

  const goToDetail = (userId: number) => {
    navigate(`${siteRoutes.viewHost}?id=${userId}`);
  };

  return (
    <div>
      <div className="flex justify-between items-center gap-4 ">
        <h1 className="text-base text-primaryText font-bold mb-6 flex items-center gap-3">
          <span
            onClick={goToBack}
            className="bg-transparentBlueBg w-[44px] h-[44px] rounded-full flex items-center justify-center cursor-pointer"
          >
            <ArrowBackIcon />
          </span>
          {`${businessDetail?.profiles?.host?.businessName || "-"}`}
        </h1>
        {/* <div className="flex items-center gap-6">
          <span className="flex items-center gap-2">
            <p className="text-sm font-bold text-primaryText">Block User</p>
            <label className="switch-field-small">
              <input type="checkbox" />
              <span className="slider"></span>
            </label>
          </span>
        
        </div> */}
      </div>
      <div className="">
        <div
          style={{
            backgroundImage: `url(${
              businessDetail?.profiles?.host?.businessPicUrl
                ? concatPathWithBackendUrl(
                    businessDetail?.profiles?.host?.businessPicUrl
                      ?.fileDownloadUri
                  )
                : editProfilePicUser
            })`,
          }}
          className="bg-cover bg-black/70 bg-gradient-black bg-center bg-no-repeat h-[150px] w-full rounded-lg"
        ></div>
        <div className="flex items-center gap-6 mt-[-50px] px-6">
          <span className="text-xl font-bold text-white">
            {`${businessDetail?.profiles?.host?.businessName || "-"}`}
          </span>
        </div>
      </div>

      <div className="mt-12">
        <div className="bg-white border-[0.3px] border-mediumGrayBorder rounded-lg p-8 my-6">
          <h1 className="text-base font-bold text-primaryText">
            Business Information
          </h1>
          <div className="mt-8 flex flex-wrap justify-between items-center gap-4">
            <div className="flex flex-col gap-6">
              <span className="text-sm font-semibold text-captionText">
                Business Name
              </span>
              <span className="text-xs text-tertiaryText capitalize">
                {businessDetail?.profiles?.host?.businessName ?? "-"}
              </span>
            </div>
            <div className="flex flex-col gap-6">
              <span className="text-sm font-semibold text-captionText">
                Business Email
              </span>
              <span className="text-xs text-tertiaryText">
                {businessDetail?.profiles?.host?.businessEmail ?? "-"}
              </span>
            </div>
            <div className="flex flex-col gap-6">
              <span className="text-sm font-semibold text-captionText">
                Phone Number
              </span>
              <span className="text-xs text-tertiaryText">
                {businessDetail?.profiles?.host?.businessPhoneNumber ?? "-"}
              </span>
            </div>
            <div className="flex flex-col gap-6">
              <span className="text-sm font-semibold text-captionText">
                Business Website
              </span>
              <span className="text-xs text-tertiaryText">
                {businessDetail?.profiles?.host?.businessWebsite ?? "-"}
              </span>
            </div>
          </div>
        </div>

        <div className="bg-white border-[0.3px] border-mediumGrayBorder rounded-lg p-8 my-6">
          <h1 className="text-base font-bold text-primaryText">Details</h1>
          <div className="mt-8 flex flex-wrap justify-between gap-4">
            <div className="flex flex-col gap-6 max-w-[200px]">
              <span className="text-sm font-semibold text-captionText max-w-[200px">
                Mission
              </span>
              <span className="text-xs text-tertiaryText">
                {businessDetail?.profiles?.host?.missionStatement ?? "-"}
              </span>
            </div>
            <div className="flex flex-col gap-6 max-w-[250px]">
              <span className="text-sm font-semibold text-captionText">
                About
              </span>
              <span className="text-xs text-tertiaryText">
                {businessDetail?.profiles?.host?.about ?? "-"}
              </span>
            </div>
            <div className="flex flex-col gap-6 max-w-[250px">
              <span className="text-sm font-semibold text-captionText">
                Industry
              </span>
              <span className="text-xs text-tertiaryText">
                {businessDetail?.profiles?.host?.industry ?? "-"}
              </span>
            </div>
            <div className="flex flex-col gap-6 max-w-[200px">
              <span className="text-sm font-semibold text-captionText">
                City
              </span>
              <span className="text-xs text-tertiaryText">
                {businessDetail?.profiles?.host?.city ?? "-"}
              </span>
            </div>
            <div className="flex flex-col gap-6 max-w-[200px">
              <span className="text-sm font-semibold text-captionText">
                State
              </span>
              <span className="text-xs text-tertiaryText">
                {businessDetail?.profiles?.host?.state ?? "-"}
              </span>
            </div>
            <div className="flex flex-col gap-6 max-w-[200px">
              <span className="text-sm font-semibold text-captionText">
                Zip Code
              </span>
              <span className="text-xs text-tertiaryText">
                {businessDetail?.profiles?.host?.zipCode ?? "-"}
              </span>
            </div>
          </div>
        </div>

        <div className="bg-white border-[0.3px] border-mediumGrayBorder rounded-lg p-8 my-6">
          <h1 className="text-base font-bold text-primaryText">
            Drivers License
          </h1>
          <div className="mt-8 flex flex-wrap sm:gap-60 items-start gap-4">
            <div className="flex flex-col gap-6">
              <span className="text-sm font-semibold text-captionText">
                Driver License or State ID
              </span>
              <div className="flex gap-3 flex-wrap ">
                <span>
                  <img
                    className="w-[152px] h-[103px] border-2 border-mediumGrayBorder rounded-lg "
                    src={
                      businessDetail?.profiles?.host?.driverLicenseFrontPicUrl
                        ?.fileDownloadUri
                        ? concatPathWithBackendUrl(
                            businessDetail?.profiles?.host
                              ?.driverLicenseFrontPicUrl?.fileDownloadUri
                          )
                        : ""
                    }
                    alt="FrontSideImage"
                  />
                </span>
                <span>
                  <img
                    className="w-[152px] h-[103px] border-2 border-mediumGrayBorder rounded-lg "
                    src={
                      businessDetail?.profiles?.host?.driverLicenseBackPicUrl
                        ?.fileDownloadUri
                        ? concatPathWithBackendUrl(
                            businessDetail?.profiles?.host
                              ?.driverLicenseBackPicUrl?.fileDownloadUri
                          )
                        : ""
                    }
                    alt="BackSideImage"
                  />
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white border-[0.3px] border-mediumGrayBorder rounded-lg p-8 my-6">
          <h1 className="text-base font-bold text-primaryText">
            Business Owner
          </h1>
          <div className="mt-8 flex flex-wrap justify-between items-center gap-8">
            <div className="flex gap-4 items-center">
              <img
                className="w-[120px] h-[120px] rounded-full object-cover"
                src={
                  businessDetail?.user?.profilePicUrl
                    ? concatPathWithBackendUrl(
                        businessDetail?.user?.profilePicUrl?.fileDownloadUri
                      )
                    : editProfilePicUser
                }
                alt="dummyImage"
              />
              <div className="flex flex-col gap-3">
                <p className="text-xl font-bold text-darkTealBlue">
                  {`${businessDetail?.user?.firstName} ${businessDetail?.user?.lastName}`}
                </p>
                {/* <span className="text-xs text-tertiaryText">
                      <ReviewGolden />
                    </span> */}
              </div>
            </div>
            <div>
              <button
                onClick={() => goToDetail(businessDetail?.profiles?.host?.userId)}
                className="px-4 py-2 text-sm bg-goldenOrangeBg text-white  rounded-lg font-semibold"
              >
                View Profile
              </button>
            </div>
          </div>
        </div>

        {/* <div className="bg-white border-[0.3px] border-mediumGrayBorder rounded-lg p-8 my-6">
          <h1 className="text-base font-bold text-primaryText">Referral</h1>
          <div className="mt-8 flex flex-wrap sm:gap-60 items-center gap-4">
            <div className="flex flex-col gap-6">
              <span className="flex gap-3 items-center">
                <img
                  className="w-10 h-10 rounded-full"
                  src={
                    businessDetail?.profiles?.host?.businessPicUrl
                      ? concatPathWithBackendUrl(
                          businessDetail?.profiles?.host?.businessPicUrl
                            ?.fileDownloadUri
                        )
                      : editProfilePicUser
                  }
                  alt="dummyImage"
                />
                <p className="text-base font-bold text-primaryText">
                  Bertha Valdez
                </p>
              </span>
              <span className="text-xs text-tertiaryText">ID: HM-2122222</span>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default ViewBusinessDetail;
